import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';

// Label
const Label = Styled.label`display: block; color: ${color.primary}`;

// Label Error
const LabelError = Styled.span`color:${(props) =>
  props.error ? color.secondary : color.black};`;

// Input
const Input = Styled.input.attrs((props) => ({
  placeholder: props.placeHolder,
  value: props.value,
}))`
width: 100%;
padding: 1.2rem 2rem;
outline: none;
border-radius: 4px;
font-size: inherit;
font-weight: inherit;
line-height: inherit;
color: ${color.primary};
border: 1px solid transparent;
border-color: ${(props) => (props.error ? color.secondary : color.light)};
&::placeholder{
color: ${color.secondaryAlt};
};
&:focus{
border-color: ${color.primary}
}
`;

class InputField extends React.Component {
  state = {
    value: '',
  };

  handleChange = ({ currentTarget }) => {
    const { value } = currentTarget;
    this.setState({ value });
  };

  render() {
    const { label, id, type, error, onBlur } = this.props;

    return (
      <div>
        <Label htmlFor={label}>
          {label[0].toUpperCase() + label.slice(1)}
          <LabelError error>{error && ' *Required'}</LabelError>
        </Label>

        <Input
          value={this.state.value}
          onChange={this.handleChange}
          type={type}
          onBlur={onBlur}
          name={id}
          {...this.props}
        />
      </div>
    );
  }
}

export default InputField;
